import { ProgressBar } from '@/components/Sherpa/Projects/Project/StatCard/ProgressBar';

interface Stat {
  completed: number;
  total: number;
}

interface StatCardProps {
  label: string;
  stats: Stat;
  loading?: boolean;
  error?: boolean;
  titleClassName?: string;
  onTitleClick?: () => void;
}

const StatCard = ({ label, stats, loading, error, titleClassName = '', onTitleClick }: StatCardProps) => {
  const percentCompleted = +((stats.completed / stats.total) * 100).toFixed(0);

  return (
    <div className='relative rounded-md bg-white p-5 w-full'>
      <p className={`font-bold ${titleClassName}`} onClick={onTitleClick}>
        {label}
      </p>
      <div className='absolute top-2 right-2 text-neutralColor-light cursor-pointer hover:text-neutralColor-medium transition duration-300 ease-in-out'></div>

      {loading ? (
        <div className='h-5 bg-gray-300 w-1/3 rounded animate-pulse mt-3' />
      ) : error ? (
        <p className='mt-3 mb-0 text-sm text-tertiaryColor-normal'>Unable to load</p>
      ) : (
        <h1 className='mt-2 mb-0 text-3xl'>
          {stats.completed} / {stats.total}
        </h1>
      )}
      <div className='relative py-5'>
        {loading ? (
          <div className='h-5 bg-gray-300 w-full rounded animate-pulse mb-0' />
        ) : error ? (
          <ProgressBar value={0} />
        ) : (
          <ProgressBar value={Number.isNaN(percentCompleted) ? 0 : percentCompleted} />
        )}
      </div>
    </div>
  );
};

export default StatCard;
